// libs
import React from 'react';

// components
import SizeGuideBottomSheetDesktop from './Desktop';
import SizeGuideBottomSheetMobile from './Mobile';

function SizeGuideBottomSheet({
  isMobile,
  onClose,
  showSizeChart,
  onSizeSelect,
  selectedSize,
  isAddedToCart,
  addToCart,
  selectedSizeName,
  outOfStockSizes,
  stockRemainingMap,
}: {
  isMobile: boolean;
  onClose: () => void;
  showSizeChart: boolean;
  onSizeSelect?: (sizeName: string) => void;
  selectedSize?: ProductDetail.ISizeOption;
  isAddedToCart?: boolean;
  addToCart?: () => void;
  selectedSizeName?: string;
  outOfStockSizes?: string[];
  stockRemainingMap?: Record<string, number>;
}) {
  if (showSizeChart === false) {
    return null;
  }

  if (isMobile) {
    return (
      <SizeGuideBottomSheetMobile
        onClose={onClose}
        onSizeSelect={onSizeSelect}
        selectedSize={selectedSize}
        isAddedToCart={isAddedToCart}
        addToCart={addToCart}
        selectedSizeName={selectedSizeName}
        outOfStockSizes={outOfStockSizes}
        stockRemainingMap={stockRemainingMap}
      />
    );
  }

  return (
    <SizeGuideBottomSheetDesktop
      onClose={onClose}
      onSizeSelect={onSizeSelect}
      selectedSize={selectedSize}
      isAddedToCart={isAddedToCart}
      addToCart={addToCart}
      selectedSizeName={selectedSizeName}
      outOfStockSizes={outOfStockSizes}
      stockRemainingMap={stockRemainingMap}
    />
  );
}

export default SizeGuideBottomSheet;
